import { useTranslation } from "react-i18next";
import MillimetreBiSquared from "../../../../../components/Math/Units/Metric/MillimetreBiSquared";
import { NumberFormatText } from "../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../components/ToolTip";

function Traegheitsmoment({ traegheitsmoment }) {
  const { t } = useTranslation("translation");

  const I_Formula = `\\displaystyle I = \\frac{\\pi}{64} \\cdot \\left( D_{a,cal}^4 - D_{i}^4 \\right)`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterTragglied.momentOfInertia")}</p>}
      indicesValue={<span>I</span>}
      formulaValue={<ToolTip id={"I_Formula"} type={IconType.FORMULA} formula={I_Formula} />}
      inputValue={
        <span className="input">
          <NumberFormatText value={traegheitsmoment} decimalScale={0} />
        </span>
      }
      unitValue={<MillimetreBiSquared />}
    />
  );
}

export default Traegheitsmoment;
